export enum ApplicationStatus {
  All = -1,
  New = 1,
  Rejected = 2,
  Approved = 3,
}
